<template lang="html">
  <v-dialog v-model="isVisible" scrollable>
    <v-card class="grey lighten-4">
      <v-toolbar flat color="grey lighten-4">
        <v-icon class="mr-1">mdi-magnify</v-icon>
        <v-toolbar-title class="text--secondary">Filters</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleFiltersPanel()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <template v-slot:extension>
          <v-tabs v-model="tab" grow background-color="grey lighten-4">
            <v-tab>Transaction</v-tab>
            <v-tab>Item</v-tab>
            <v-tab>Tender</v-tab>
            <v-tab>Receipt</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0 grey lighten-4">
        <v-tabs-items v-model="tab" grow background-color="grey lighten-4">
          <v-tab-item>
            <v-container fluid>
              <filter-form label="transactionID" :operators="['=']" hint="Example: 7-0-0-20200101000000-1-1" icon="mdi-numeric" />
              <combo-box-filter-form label="businessUnitID"
                                     :operators="['=']"
                                     :items="businessUnits"
                                     :print-item="(bu) => bu.id + ' - ' + bu.name+ ' (' + bu.countryCode +')'"
                                     item-value="id"
                                     hint="Example: 7-0-0" icon="mdi-domain"
              />
              <filter-form label="workstationID" hint="Example: 1" icon="mdi-monitor" />
              <filter-form label="sequenceNumber" :operators="['=']" hint="Example: 1" icon="mdi-format-list-numbered" />
              <filter-form label="transaction.retailTransaction.specialOrderNumber" :operators="['=']" hint="Example of order number: fr489286284" icon="shopping_cart" />
              <filter-form label="transaction.retailTransaction.lineItem.saleForDelivery.itemID" :operators="['=']" hint="Example of shipping group ID: sgfr489286284" icon="local_shipping" />
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid>
              <v-radio-group row v-model="itemTransactionType" class="py-0" :disabled="expansionPanel == 2" >
                <v-radio label="Sale" value="sale" class="offset-3 px-2"></v-radio>
                <v-radio label="Return" value="return" class="offset-1"></v-radio>
              </v-radio-group>

              <v-expansion-panels focusable accordion v-model="expansionPanel">
                <v-expansion-panel>
                  <v-expansion-panel-header>ITEM</v-expansion-panel-header>
                  <v-expansion-panel-content class="pa-0 grey lighten-4">
                    <v-container fluid>
                      <filter-form
                              :label="itemTransactionType + '.itemID'"
                              :operators="['=']"
                              hint="Example: 123456" icon="mdi-numeric"
                      />
                      <combo-box-filter-form
                              :label="itemTransactionType + '.merchandiseHierarchyID'"
                              :operators="['=', '!=']"
                              :items="itemCategories"
                              :print-item="(cat) => cat.id + ' - ' + cat.name"
                              item-value="name"
                              hint="Example: DKT:PlusVoucher" icon="mdi-tag"
                      />
                      <filter-form
                              :label="itemTransactionType + '.extendedAmount'"
                              hint="Example: 10.00" icon="mdi-currency-usd"
                      />
                      <filter-form
                              :label="itemTransactionType + '.serialNumber'"
                              :operators="['=']"
                              hint="Example: 123456" icon="mdi-identifier"
                      />
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>RETAIL PRICE MODIFIER</v-expansion-panel-header>
                  <v-expansion-panel-content class="pa-0 grey lighten-4">
                    <v-container fluid>
                      <combo-box-filter-form
                              label="transaction.retailTransaction.lineItem.sale.retailPriceModifier.amount.value"
                              hint="Example: 10.00" icon="mdi-currency-usd"
                      />
                      <filter-form
                              label="transaction.retailTransaction.lineItem.sale.retailPriceModifier.priceDerivationRule.reasonCode.description"
                              :operators="['=', '!=']"
                              hint="Example: DKT:PromotionalPrice" icon="mdi-tag"
                      />
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>

              </v-expansion-panels>

            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid>
              <combo-box-filter-form
                      label="transaction.retailTransaction.lineItem.tender.reasonCode.value"
                      :operators="['=']"
                      :items="tenders"
                      :print-item="(tender) => tender.code + ' - ' + tender.type"
                      item-value="code"
                      hint="Example: 3" icon="mdi-numeric"
              />
              <combo-box-filter-form
                      label="tender.tenderType"
                      :operators="['=', '!=']"
                      :items="tenders"
                      :print-item="(tender) => tender.type + ' - ' + tender.code"
                      item-value="type"
                      hint="Example: DKT:CreditCard" icon="mdi-tag"
              />
              <filter-form
                      label="tender.amount"
                      hint="Example: 10.00" icon="mdi-currency-usd"
              />
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid>
              <filter-form label="receiptNumber" :operators="['=']" hint="Example: 660700000000010000000120200402220700" icon="mdi-barcode" />
              <filter-form label="receipt" :operators="['=', '!=']" hint="Example: Cash £20.00" icon="mdi-receipt" />
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>

</template>

<script>
  import {SEARCH_NS} from "@/store/modules/search/constants";
  import {mapActions, mapGetters} from 'vuex'

  import FilterForm from "@/components/home/filter/FilterForm"
  import {REFERENTIEL_NS} from "@/store/modules/referentiel";
  import ComboBoxFilterForm from "@/components/home/filter/ComboBoxFilterForm";

  export default {
    components: { ComboBoxFilterForm, FilterForm},
    data: () => ({
      tab: '',
      itemTransactionType: "sale",
      expansionPanel: 0
    }),
    computed: {
      ...mapGetters(REFERENTIEL_NS, [
        'businessUnits',
        'itemCategories',
        'taxGroups',
        'taxNames',
        'tenders'
      ]),
      isVisible: {
        get() {
          return this.$store.getters[`${SEARCH_NS}/isFiltersPanelVisible`]
        },
        set() {
          this.$store.dispatch(SEARCH_NS + '/toggleFiltersPanel')
        }
      }
    },
    methods: {
      ...mapActions(SEARCH_NS, ['toggleFiltersPanel']),
    }
  }
</script>

<style lang="css">
.v-window.v-item-group.theme--light.v-tabs-items {
  background-color: #f5f5f5;
}

</style>
